webpackJsonp([94331584923718],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(57);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Akce = function Akce() {
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Muvko - Akce' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Akce'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Z\xE1bavu si u\u017E\xEDv\xE1me nejenom na tr\xE9ninc\xEDch, ale tak\xE9 mimo t\u011Blocvi\u010Dnu. Spole\u010Dn\u011B jezd\xEDme a z\xFAro\u010Dujeme d\u0159inu na Spartan Race, nebo t\u0159eba Red Bull 400.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Tou nejobl\xEDben\u011Bj\u0161\xED akc\xED je Muvko Camp, kde si po\u0159\xE1dn\u011B zamak\xE1\u0161, vypot\xED\u0161 krev, ale taky zasm\u011Bje\u0161, nad\xFDch\xE1\u0161 se \u010Derstv\xE9ho vzduchu a na\u010Derp\xE1\u0161 spoustu pozitivn\xED energie.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Krom\u011B sportovn\xEDch v\xFDkon\u016F spolu podnik\xE1me i jin\xE9 aktivity, jako jsou konzerty, rafty, v\xFDlety a v\u0161e, co T\u011B jenom napadne.'
	    )
	  );
	};
	
	exports.default = Akce;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-akce-js-8401c3df4fee4af3a676.js